import React from "react";
import {
  Text,
  Avatar,
  Stack,
  HStack,
  Image,
  Box,
  Flex,
  Circle,
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import {
  textSecondary,
  color8,
  secondary,
  buttonBlueText,
  buttonBlue,
  backgroundLight,
} from "../../../../../utils/colors";
import dayjs from "dayjs";
import StatusBadge from "../../../../../components/badges/StatusBadge";
import MoreButtonLite from "../../../../../components/buttons/MoreButtonLite";
import StatusButtonNewLite from "../../../../../components/buttons/StatusButtonNewLite";
import { TbCake, TbDental } from "react-icons/tb";

export const columns = (
  translate,
  navigate,
  isMobile,
  textPrimaryMode,
  whiteMode,
  t,
  handleSortChange,
  deleteHandler,
  setUserId,
  setShowDeleteConfirmation,
  isAdmin
) => {
  const allColumns = [
    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text>{translate("user.columnUser")}</Text>
          </Flex>
        </Flex>
      ),
      disableSortBy: true,
      width: 300,
      accessor: "lastName",
      Cell: ({ row }) => {
        const { logo, slug, clinicName } = row.original;
        // const name = `${lastName} ${firstName}`;

        return (
          <HStack gap={2}>
            {logo ? (
              <Image
                src={logo}
                h="2.5rem"
                w="2.5rem"
                borderRadius="100%"
                objectFit="cover"
                mr="0.25rem"
              />
            ) : (
              <Flex
                align="center"
                justify="center"
                h="2.5rem"
                w="2.5rem"
                borderRadius="100%"
                bg={backgroundLight}
                // border={`1px solid ${newBorder}`}
                mr="0.25rem"
              >
                <Icon as={TbDental} color={textSecondary} fontSize="0.875rem" />
              </Flex>
            )}

            <Stack gap={0} textAlign="left">
              <Text
                fontSize="0.875rem"
                color={textPrimaryMode}
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxW={["80%", "160px"]}
                textTransform="capitalize"
              >
                {clinicName || slug}
                {/* <Text as="span" fontWeight="400" ml={1}>
                  {firstName}
                </Text> */}
              </Text>
              {/* <Text
                fontSize="xs"
                color={textSecondary}
                fontWeight="500"
                isTruncated // This will add ellipsis
                maxW="220px"
              >
               {email}
              </Text> */}
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text>{translate("employee.columnRole")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "role",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { role } = row.original;

        // console.log("row.original", row.original);

        return (
          <Flex align="center" w="100%">
            <Text
              fontSize="0.8rem"
              color={textSecondary}
              fontWeight="500"
              whiteSpace="nowrap"
              isTruncated
              maxWidth="160px"
            >
              {translate(`role.${role}`)}
            </Text>
          </Flex>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("rolePermission")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("employee.columnRolePermission")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "rolePermission",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { rolePermission } = row.original;

        // console.log("row", row);

        return (
          <>
            <Text
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
              textTransform="capitalize"
              textAlign="left"
            >
              {translate(`rolePermission.${rolePermission}`)}
            </Text>
          </>
        );
      },
    },
    {
      Header: () => (
        <Flex w="100%" h="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id } = row.original;

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNewLite
              p="0.5rem 3.5rem"
              // w="200px"
              size="md"
              currentStatus={status}
              options="user"
            />
            {/* <MoreButtonLite
              isSmall
              id={_id}
              viewHandler={() => {
                navigate(`/employees/${_id}`);
              }}
              viewLabel={translate("employee.viewEmployee")}
              deleteHandler={true}
              // deleteButtonDisabled={!isAdmin || isCurrentUser}
              setShowDeleteConfirmation={() => {
                setUserId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
              }}
            /> */}

            {/* <MoreButtonLite
              id={_id}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                // setUserId(_id); // Set the user ID for deletion
                // setShowDeleteConfirmation(true); // Open confirmation modal
                // setPatientName(
                //   row.original.lastName + " " + row.original.firstName
                // );
              }}
            /> */}
          </HStack>
        );
      },
    },

    // {
    //   Header: () => (
    //     <Box onClick={() => handleSortChange("status")} w="100%">
    //       <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
    //         <Text mr={2}>{translate("patient.columnStatus")}</Text>
    //       </Flex>
    //     </Box>
    //   ),
    //   accessor: "status",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { status, _id } = row.original;

    //     const handleUpdateStatus = (newStatus) => {
    //       dispatch(updateUserStatus(_id, newStatus));
    //     };

    //     const isCurrentUser = loggedInUserId === row.original._id;

    //     return (
    //       <HStack gap={0} justify="flex-end">
    //         <StatusButton
    //           currentStatus={status && status}
    //           onUpdateStatus={handleUpdateStatus}
    //           options="active"
    //           isUnclickable={!isAdmin}
    //         />
    //         <MoreButton
    //           id={_id}
    //           deleteHandler={deleteEmployeeHandler}
    //           deleteName={row.original.firstName + " " + row.original.lastName}
    //           deleteButtonDisabled={!isAdmin || isCurrentUser}
    //           editHandler={(e) => {
    //             e.stopPropagation();
    //             openEditEmployeeSidePanelModal(_id);
    //           }}
    //           editButtonDisabled={!isAdmin}
    //         />
    //       </HStack>
    //     );
    //   },
    // },
  ];

  return isAdmin
    ? allColumns
    : allColumns.filter((column) => column.accessor !== "rolePermission");
};
